<template>
  <v-dialog v-model="localDialog" max-width="450" persistent>
    <v-card class="confirm-dialog">
      <v-card-title class="text-h6 font-weight-bold confirm-title">
        {{ title }}
      </v-card-title>
      
      <v-card-text class="pb-2 confirm-text">
        {{ message }}
        <div v-if="userInfo" class="mt-3 user-info">
          <div class="text-subtitle-2 font-weight-medium">{{ userInfo.name }}</div>
          <div class="text-body-2 text-medium-emphasis">{{ userInfo.email }}</div>
        </div>
      </v-card-text>
      
      <v-card-actions class="pa-4 pt-2">
        <v-spacer></v-spacer>
        
        <v-btn
          variant="outlined"
          @click="cancel"
          :disabled="loading"
          class="cancel-btn"
        >
          Cancelar
        </v-btn>
        
        <v-btn
          :color="confirmColor"
          :loading="loading"
          @click="confirm"
          class="confirm-btn ml-2"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  dialog: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    default: 'Confirmar Acción'
  },
  message: {
    type: String,
    default: '¿Estás seguro de que quieres continuar?'
  },
  confirmText: {
    type: String,
    default: 'Confirmar'
  },
  confirmColor: {
    type: String,
    default: 'error'
  },
  loading: {
    type: Boolean,
    default: false
  },
  userInfo: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['update:dialog', 'confirm', 'cancel'])

const localDialog = computed({
  get: () => props.dialog,
  set: (value) => emit('update:dialog', value)
})

const confirm = () => {
  emit('confirm')
}

const cancel = () => {
  emit('cancel')
  localDialog.value = false
}
</script>

<style scoped>
.confirm-dialog {
  border-radius: 12px !important;
  background: #FFFFFF;
}

.confirm-title {
  background: linear-gradient(135deg, #0A192F 0%, #112240 100%);
  color: #FFFFFF !important;
  border-radius: 12px 12px 0 0;
  padding: 20px 24px 16px;
}

.confirm-text {
  padding: 20px 24px 8px;
  color: #334155;
  line-height: 1.5;
}

.user-info {
  background: #F8FAFC;
  padding: 12px 16px;
  border-radius: 8px;
  border-left: 4px solid #0A192F;
}

.cancel-btn {
  border-color: #CBD5E1 !important;
  color: #64748B !important;
  text-transform: none;
  font-weight: 500;
  border-radius: 8px;
  padding: 0 24px;
  height: 40px;
}

.cancel-btn:hover {
  background-color: #F1F5F9 !important;
  border-color: #94A3B8 !important;
}

.confirm-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  padding: 0 24px;
  height: 40px;
  box-shadow: 0 2px 4px rgba(239, 68, 68, 0.2);
}

.confirm-btn:hover {
  box-shadow: 0 4px 8px rgba(239, 68, 68, 0.3);
}

@media (max-width: 600px) {
  .confirm-dialog {
    margin: 16px;
  }
  
  .confirm-title {
    padding: 16px 20px 12px;
    font-size: 1.1rem;
  }
  
  .confirm-text {
    padding: 16px 20px 8px;
  }
  
  .v-card-actions {
    padding: 16px 20px;
    flex-direction: column;
    gap: 8px;
  }
  
  .cancel-btn,
  .confirm-btn {
    width: 100%;
    margin: 0 !important;
  }
}
</style>